import styled, { css } from 'styled-components'

import FluffySlider from '@gotamedia/fluffy/Slider'

import { themeHelpers } from '@gotamedia/fluffy/theme'

const Slider = styled(FluffySlider)<{width: number, legacy?: boolean}>`
    height: ${({ legacy }) => legacy ? 204 : 196}px;
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : "height: 216px;"}`)};
    width: ${({ width }) => `${width}px`};
    margin: auto;
    ${themeHelpers.isSmallDevice(css`
        width: 100vw;
    `)};
`

const CardWrapper = styled.div<{width?: number, legacy?: boolean}>`
    display: flex;
    flex-direction: column; 
    height: ${({ legacy }) => legacy ? 170 : 162}px; 
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : "height: 183px;"}`)};
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "width: 170px" : "width: 300px;"}`)};
    box-shadow: 0px 2px 4px rgba(46, 42, 37, 0.12);
    background: #fff;
    margin: 6px;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    ${themeHelpers.isLargeDevice(css`
        width: 160px;
        min-width: 160px;
    `)}
    ${(props) => props.width === undefined ? undefined : css`
        width: ${props.width}px;
        margin-right: 10px;
    `}
`

const SliderContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`

const CardContainer = styled.div`
    display: flex;
    flex-direction: row;
`

const ImageContainer = styled.div<{legacy?: boolean}>`
    display: flex;
    max-height: 100px;
    margin-top: 5px;
    margin-bottom: ${({ legacy }) => legacy ? 15 : 5}px; 
    ${({ legacy }) => themeHelpers.isSmallDevice(css`${legacy ? "" : css`
        margin: 0;
        max-height: 70px;
    `}`)};
`

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 8px; 
    padding-right: 8px;
    width: 100%;  
`

const CardImage = styled.img`
    width: 114px;
    height: 57px;
    aspect-ratio: 2/1;
    object-fit: contain;
    padding: 8px;
`

const CardName = styled.span`
    height: 100%;
    font-size: 14px;
    font-family: "Sanomat Sans Text";
    font-weight: 700;
    height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`

const CardInfo = styled.span`
    font-size: 12px;
    margin-top: 2px;
    display: flex; 
    flex-direction: row;
    font-family: "Sanomat Sans Text";
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey[2]};
`

const InfoText = styled.span`
    margin-left: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: "Sanomat Sans Text";
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
`


export {
    Slider,
    SliderContainer,
    CardWrapper,
    CardContainer,
    CardImage,
    CardName,
    CardInfo,
    InfoText,
    ImageContainer,
    TextContainer
}
